<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="绑定电梯"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="360px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="项目：">
          <el-select
            size="mini"
            v-model="form.projectId"
            filterable
            placeholder="请选择项目"
            clearable
            reserve-keyword
            :remote="true"
            :remote-method="searchProjectList"
            @visible-change="searchProjectList('')"
            @change="chooseProject"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.projectName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电梯：" prop="liftIdList" class="mr0">
          <el-select
            size="mini"
            v-model="form.liftIdList"
            filterable
            placeholder="请选择电梯"
            clearable
            reserve-keyword
            :multiple="true"
            collapse-tags
            :remote="true"
            :remote-method="searchLiftList"
            @visible-change="searchLiftList('')"
          >
            <el-option
              v-for="item in liftList"
              :key="item.liftId"
              :label="item.liftLocation"
              :value="item.liftId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button
        class="plr28"
        :loading="loading"
        type="primary"
        size="mini"
        @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { saveAssign, saveBatch } from "@/api/TaskAssigned";
import { getProjectSimpleList } from "@/api/MaintenanceWorkOrder";
import { getLiftSimpleList, getUserSimpleList } from "@/api/MaintenancePlan";
import {
  bindLift
} from "@/api/CustomerManagement";
import { mapState } from "vuex";
export default {
  data() {
    return {
      form: {
        projectId: "",
        liftIdList: [],
        customerId: null
      },
      projectList: [],
      liftList: [],
      rules: {
        projectId: [
          {
            required: true,
            message: "请输入选择项目",
            trigger: "blur",
          },
        ],
        liftIdList: [
          {
            required: true,
            message: "请选择电梯",
            trigger: "blur",
          },
        ],
      },
      loading: false,
    };
  },
  props: {
    clientForm: {
      type: Object,
      required: false,
      default: () => ({
        customerName: "",
        customerPhone: "",
        customerAddress: "",
        id: "",
        propertyUnitIdList: [],
      }),
    },
  },
  computed: {
    ...mapState("userStore/user", ["user"]),
  },
  created() {
    console.log(this.clientForm)
    if (this.clientForm && this.clientForm.id) {
      this.form = { customerId: this.clientForm.id};
      this.searchProjectList();
      this.searchLiftList();
    }
  },

  methods: {
    async searchProjectList(keyword) {
      const res = await getProjectSimpleList({
        keyword: keyword,
        size: 1000,
      });
      if (res.code === 200) {
        this.projectList = res.data;
      }
    },
    async searchLiftList(keyword) {
      if (!this.form.projectId) {
        return;
      }
      const res = await getLiftSimpleList({
        keyword: keyword,
        size: 100,
        projectId: this.form.projectId,
      });
      if (res.code === 200) {
        this.liftList = res.data;
      }
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    chooseProject() {
      this.form.liftIdList = null;
    },
    async handleConfirm() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const params = {
            ...this.form,
          };
          this.loading = true;
          const res = await bindLift(params);
          if (res.code === 200) {
            this.$message.success("保存成功");
            this.$emit("confirm");
          }
          this.loading = false;
        }
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/CustomerManagement/components/AddAssigne.vue